exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h6.contact-links[data-v-e2a67e1c]{display:inline-block}@media (max-width:575px){h6.contact-links[data-v-e2a67e1c]{font-size:14px}}", ""]);

// exports
